module.exports = __webpack_public_path__ + "img/case-lg-6.ce5cff40.jpg";